const ROLE_ACTION_TYPES = {
  LOAD_ROLES: 'role/LOAD_ROLES',
};

export default ROLE_ACTION_TYPES;
